import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import './style.css'

export default function footer() {
    return (
        <div className="dashboard-footer">
        <hr />
            <Container>
                <Row>
                    <Col md={7}>
                        <Row className="footer-dashboard-list">
                            <Col md={3}>
                                <h3>Malmora</h3>
                                 {
                                     Malmora.map((data, i) => {
                                         return (
                                             <li key={i}>{data.text}</li>
                                         )
                                     })
                                 }
                            </Col>
                            <Col md={4}>
                                <h3>Bantuan</h3>
                                 {
                                     Bantuan.map((data, i) => {
                                         return (
                                             <li key={i}>{data.text}</li>
                                         )
                                     })
                                 }

                                 <h3>Ikuti kami</h3>

                                  {
                                     IkutKami.map((data, i) => {
                                         return (
                                             <img className="dashboard-icons-footer" key={i} src={data.img} alt="icons" />
                                         )
                                     })
                                 }
                            </Col>
                            <Col md={5}>
                                <h3>Download Aplikasi</h3>
                                  <img className="google-play" src="asset/dashboard/footer/google-play.png" alt="google-play" />
                            </Col>
                        </Row>
                    </Col>
                     <Col md={5}>
                        <img className="ilustrasi" src="asset/dashboard/footer/ilustrasi.png" alt="ilustarsi" />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}


const Malmora = [
    {text:"about Us"}, {text:"about Us"}, {text:"about Us"}, {text:"about Us"}, {text:"about Us"}
]

const Bantuan = [
    {text:"about Us"}, {text:"about Us"}
]

const IkutKami = [
    {img:"asset/dashboard/icons/facebook.svg"},
    {img:"asset/dashboard/icons/instagram.svg"},
    {img:"asset/dashboard/icons/whatsapp.svg"},
    {img:"asset/dashboard/icons/linkedin.svg"},
    {img:"asset/dashboard/icons/gmail.svg"}
]